import script from "./AppAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAlert.vue?vue&type=script&setup=true&lang=ts"

import "./AppAlert.vue?vue&type=style&index=0&id=25a9f4bc&lang=scss"

const __exports__ = script;

export default __exports__